import React from 'react';
import PropTypes from 'prop-types';

import {
	FormControl,
	withStyles,
	Input,
	InputLabel,
	MenuItem,
	Select,
	Typography
} from '@material-ui/core';

const styles = theme => ({
	dropdown: {
		width: '100%'
	}
});

const FancyLabel = props => (
	<div
		style={{
			display: 'flex',
			textAlign: 'center',
			position: 'relative'
		}}
	>
		<div
			Typography
			style={{ width: '40%', flexFlow: 'row-reverse' }}
			className="fancyLabelLine"
		>
			<div />
		</div>
		<Typography variant="caption" style={{ width: '20%' }}>
			{props.text}
		</Typography>
		<div
			Typography
			style={{ width: '40%', flexFlow: 'row' }}
			className="fancyLabelLine"
		>
			<div />
		</div>
	</div>
);

class FormDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.state = {
			disabled: false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.meta.touched ||
			nextProps.input.value !== this.props.input.value ||
			nextProps.p_value !== this.props.p_value
		) {
			this.forceUpdate();
		}
		this.forceUpdate();
	}

	shouldComponentUpdate() {
		this.forceUpdate();
		return true;
	}

	handleChange(event) {
		if (this.props.input.onChange) {
			this.props.input.onChange(event.target.value);
		}

		if (this.props.onValueChange) {
			this.props.onValueChange(event.target.value);
		}
	}

	render() {
		let lValue = this.props.input.value
			? this.props.input.value
			: this.props.options[0].value;

		const items = this.props.options.map((option, i) => {
			if (typeof option === 'object' && option) {
				if (option.hidden) return null;
				return (
					<MenuItem
						value={option.value}
						key={option.value}
						className={!option.value ? 'dropdownEmpty' : ''}
					>
						{!option.value ? (
							<div
								style={{
									display: 'block',
									width: '100%',
									cursor: 'default',
									marginBottom: '10px'
								}}
							>
								<div
									className="emptyOption"
									style={!lValue ? { background: 'rgba(0, 0, 0, 0.08)' } : {}}
								>
									{option.displayValue}
								</div>
								<FancyLabel text={'or'} />
							</div>
						) : (
							option.displayValue
						)}
					</MenuItem>
				);
			} else {
				return (
					<MenuItem value={option} key={i}>
						{option}
					</MenuItem>
				);
			}
		});

		const {
			meta: { error }
		} = this.props;

		let touched = this.props.input.value ? true : false;

		let trySubmit = this.props.checkValidation ? true : false;

		let validationError =
			(lValue === 'validationError' || !lValue) &&
			touched &&
			this.props.isrequired
				? true
				: (lValue === 'validationError' || !lValue) &&
				  this.props.isrequired &&
				  trySubmit
				? true
				: false;

		let errors =
			(error && (touched || this.props.fixedValue)) ||
			(error && trySubmit) ||
			validationError;

		var label = this.props.label;

		return (
			<FormControl>
				<InputLabel htmlFor={label} style={errors ? { color: '#f44336' } : {}}>
					{this.props.label}
				</InputLabel>
				<Select
					className={this.props.classes.dropdown}
					value={lValue}
					disabled={this.state.disabled}
					onChange={this.handleChange}
					input={<Input id="" />}
					autowidth={'true'}
					id={label}
					error={errors && true}
					style={errors ? { color: '#f44336' } : {}}
				>
					{items}
				</Select>
				{errors ? <Typography className="errorText">{error}</Typography> : null}
			</FormControl>
		);
	}
}

FormDropdown.propTypes = {
	input: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	label: PropTypes.string.isRequired
};

export default withStyles(styles)(FormDropdown);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/FormDropDown.js